import React from 'react';
import groupPath from '../utils/url/groupPath';
import styles from './MembershipGroups.module.scss';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';
import Link from '../utils/router/Link';

const MEMBERSHIP_GROUPS_GROUPS = gql(`
  fragment MembershipGroups_groups on Group {
    id
    name
    ...groupPath_group
  }
`);

interface MembershipGroupsProps {
  membershipGroups: DocumentType<typeof MEMBERSHIP_GROUPS_GROUPS>[];
}

const MembershipGroups = ({ membershipGroups }: MembershipGroupsProps) => (
  <ul className={styles.content}>
    {membershipGroups && membershipGroups.length > 0 ? (
      membershipGroups.map((membershipGroup) => (
        <li key={membershipGroup.id}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
          <Link className={styles.group} to={groupPath(membershipGroup)!}>
            {membershipGroup.name}
          </Link>
        </li>
      ))
    ) : (
      <div className={styles.empty}>No memberships yet</div>
    )}
  </ul>
);

export default MembershipGroups;
